'use strict';

/*@ngInject*/
module.exports = function ($rootScope) {
	return {
		scope: {
			message: '<',
			isModalOpen: '='
		},
		bindToController: true,
		controllerAs: 'vm',
		controller: function controller() {
			var vm = this;
			if (this) {
				setTimeout(function () {
					document.getElementById("close").click();
				}, 3000);
			}
			vm.rootScope = $rootScope;

			vm.closeModal = function () {
				vm.rootScope.showSuccessModal = false;
				vm.isModalOpen = false;
			};
		},
		template: require('./success-message-modal.directive.html')
	};
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/success-message-modal.directive.js
 **/